import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Truck } from "lucide-react";

interface DeliverySectionProps {
  deliveryInfo: string;
  onDeliveryInfoChange: (value: string) => void;
  deliveryEnabled: boolean;
  onDeliveryEnabledChange: (value: boolean) => void;
  hideEnableToggle?: boolean;
}

export function DeliverySection({
  deliveryInfo,
  onDeliveryInfoChange,
  deliveryEnabled,
  onDeliveryEnabledChange,
  hideEnableToggle = false,
}: DeliverySectionProps) {
  return (
    <div className="space-y-4">
      {!hideEnableToggle ? (
        <div className="flex items-center justify-between rounded-lg border p-4 bg-muted/30">
          <div className="flex items-center gap-3">
            <Truck className="w-5 h-5 text-agent-primary" />
            <div>
              <Label className="text-sm font-medium">Incluir no prompt</Label>
              <p className="text-xs text-muted-foreground">
                O agente informará sobre entregas quando relevante
              </p>
            </div>
          </div>
          <Switch checked={deliveryEnabled} onCheckedChange={onDeliveryEnabledChange} />
        </div>
      ) : null}
      <div className="space-y-2">
        <Label className="text-sm font-medium">Informações de Entrega</Label>
        <Textarea
          value={deliveryInfo}
          onChange={(e) => onDeliveryInfoChange(e.target.value)}
          placeholder={`Descreva as formas de entrega, prazos e regras...

Exemplo:
• Frete grátis para compras acima de R$ 200
• Entrega em 3-5 dias úteis para capitais
• Retirada na loja disponível
• Enviamos para todo o Brasil`}
          className="min-h-[140px] resize-none"
          disabled={!deliveryEnabled}
        />
      </div>
    </div>
  );
}
